import type { NodeTypes } from '@mv/core/model/heim/richText';
import { replacePlaceholders } from '../replacePlaceholders';
import type { RichTextContext } from '../RichText';
import { getPlainText } from './getPlainText';

export type CollectedLink = { label: string; onPress: () => void };

export function collectLinks(nodes: NodeTypes[] | undefined, context: RichTextContext): CollectedLink[] {
	return (
		nodes?.flatMap((node) => {
			if (node.type !== 'link' && node.type !== 'autolink') return collectLinks(node.children, context);

			const fields = node.fields as
				| { url?: string; linkType?: string; doc?: { value?: { slug?: string } } }
				| undefined;
			const topLevelUrl = (node as NodeTypes & { url?: unknown }).url;
			const url =
				typeof fields?.url === 'string' ? fields.url : typeof topLevelUrl === 'string' ? topLevelUrl : undefined;
			const label = getPlainText(node.children, context.replacements);
			const { onPress } = context.resolveLink({
				node,
				href: url === undefined ? undefined : replacePlaceholders(url, context.replacements),
				linkType: fields?.linkType,
				slug: fields?.doc?.value?.slug,
				label,
			});

			return onPress ? [{ label: label || url || '', onPress }] : [];
		}) ?? []
	);
}
